import React from "react"
import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { ApiQueryAutocomplete } from "../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { EntityTypeFilter } from "../../../admin/entities/supportEntitiesTypes"
import {
    fetchEntitiesSimple,
    FetchSupportEntitySimpleResponse,
    SupportEntityQuery,
} from "../../../admin/entities/supportEntityApi"

const useStyles = makeStyles()(() => ({
    input: {
        width: "15rem",
    },
}))

type SelectMerchantProps = Readonly<{
    setMerchantId: React.Dispatch<React.SetStateAction<number | undefined>>
    merchantId: number | undefined
}>

function transformData(data: FetchSupportEntitySimpleResponse) {
    return data.entities
}

export function SelectMerchantAutocomplete({ setMerchantId, merchantId }: SelectMerchantProps) {
    const { classes } = useStyles()

    const {
        isError,
        isLoading,
        data = [],
    } = useApiQuery(fetchEntitiesSimple, {
        queryName: SupportEntityQuery.LIST_SIMPLE,
        dependencies: {
            type: EntityTypeFilter.MERCHANT,
        },
        select: transformData,
    })

    return (
        <LocalizedStrict id="support-printer-queue-merchant-label" attrs={{ label: true }}>
            <ApiQueryAutocomplete
                label="Merchant"
                isLoading={isLoading}
                isError={isError}
                disableClearable
                value={data.find((merchant) => merchant.id === merchantId) || undefined}
                options={data}
                defaultValue={data[0]}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => `${option.name}`}
                renderOption={(props, option) => (
                    <Box component="li" sx={{ ml: "0.5rem" }} {...props}>
                        {option.name}
                    </Box>
                )}
                onChange={(_, value) => {
                    setMerchantId(value.id)
                }}
                className={classes.input}
            />
        </LocalizedStrict>
    )
}
